import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

// Import components
import Hero from './components/Hero';
import GroomBride from './components/GroomBride';
import InfoSection from './components/InfoSection';
import Footer from './components/Footer';

// Import pages
import InvitePage from './pages/InvitePage';
import InviteError from './pages/InviteError';

function App() {
  return (
    <Routes>
      {/* Generic landing page route */}
      <Route
        path="/"
        element={
          <div className="wedding-app">
            {/* Hero Section */}
            <Hero />

            {/* Groom & Bride Section */}
            <GroomBride />

            {/* Ceremony Section */}
            <InfoSection
              type="ceremony"
              time="17:00 h"
              venue="Crkva sv. Nikole Biskupa"
              address="Medpotoki ul. 1, Zagreb"
              mapsUrl="https://maps.app.goo.gl/TaLdY4t1gvLZC9wm8"
            />

            {/* Reception Section */}
            <InfoSection
              type="reception"
              time="19:00 h"
              venue="Restoran Dubravkin put"
              address="Dubravkin put 2, Zagreb"
              note="Okupljanje, potom večera, ples i dobra zabava!"
              mapsUrl="https://maps.app.goo.gl/P4MxhEG1AmQZvrNV9"
            />

            {/* Footer */}
            <Footer />
          </div>
        }
      />

      {/* Generic landing page route, without hero image */}
      <Route
        path="/poziv"
        element={
          <div className="wedding-app">
            {/* Hero Section (no image) */}
            <Hero imageless />

            {/* Groom & Bride Section */}
            <GroomBride />

            {/* Ceremony Section */}
            <InfoSection
              type="ceremony"
              time="17:00 h"
              venue="Crkva sv. Nikole Biskupa"
              address="Medpotoki ul. 1, Zagreb"
              mapsUrl="https://maps.app.goo.gl/TaLdY4t1gvLZC9wm8"
            />

            {/* Reception Section */}
            <InfoSection
              type="reception"
              time="19:00 h"
              venue="Restoran Dubravkin put"
              address="Dubravkin put 2, Zagreb"
              note="Okupljanje, potom večera, ples i dobra zabava!"
              mapsUrl="https://maps.app.goo.gl/P4MxhEG1AmQZvrNV9"
            />

            {/* Footer */}
            <Footer />
          </div>
        }
      />

      {/* Personalized invitation route */}
      <Route path="/pozivnica/:endpoint" element={<InvitePage />} />

      {/* Personalized info route — same page, uses label_2 instead of label */}
      <Route
        path="/info/:endpoint"
        element={
          <InvitePage
            labelField="label_2"
            rpcName="get_guest_by_endpoint_2"
            showRsvp={false}
            showRouteSection={true}
            ceremonyDescription="Sveta misa i obred vjenčanja održat će se zajedno u crkvi, u jednom svečanom slavlju."
            receptionDirectionsButtonLabel="Lokacija"
            receptionNote={null}
            receptionParking={{
              text: 'Za parkiranje preporučamo obližnju garažu Tuškanac, na samo 3 minute hoda od restorana.',
              buttonLabel: 'Lokacija garaže',
              mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Gara%C5%BEa+Tu%C5%A1kanac+Zagreb',
            }}
            receptionDietaryNote="Ukoliko imate kakvih alergija, posebnih prehrambenih potreba ili ste vegetarijanci, slobodno nam se javite kako bismo na vrijeme obavijestili restoran."
            footerContacts={[
              { name: 'Ana', phone: '099 7891 180' },
              { name: 'Josip', phone: '091 9122 577' },
            ]}
            receptionTimeline={[
              {
                time: '19:00',
                title: 'Dolazak',
                description:
                  'Dočekujemo Vas na terasi uz fingerfood, šampanjac i osvježavajuća pića.',
              },
              {
                time: '20:00',
                title: 'Ulaz u restoran',
                description:
                  'Ulazimo u restoran i započinjemo svečanu večeru.',
              },
            ]}
          />
        }
      />

      {/* 404 catch-all route */}
      <Route path="*" element={<InviteError variant="not_found" />} />
    </Routes>
  );
}

export default App;
